import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { onlineManager } from '@tanstack/react-query'
import { AppLayout } from '@/components/layout/app-layout'
import { AUTH_KEYS } from '@/features/auth/hooks'
import { fetchMe } from '@/features/auth/api'
import type { SessionUser } from '@/types/auth'

// Pathless layout for every signed-in page. The guard resolves the session
// cookie via /auth/me — HttpOnly cookies are invisible to JavaScript, so
// this round-trip is the source of truth for "am I logged in?".
export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context }) => {
    try {
      await context.queryClient.ensureQueryData({
        queryKey: AUTH_KEYS.me,
        queryFn: fetchMe,
      })
    } catch {
      // Offline with a restored session: /auth/me is unreachable and the
      // cookie can't be inspected from JS — let the user in on the cached
      // session (persistence is tenant-scoped by subdomain origin).
      const cached = context.queryClient.getQueryData<SessionUser | null>(AUTH_KEYS.me)
      if (!onlineManager.isOnline() && cached) return
      throw redirect({ to: '/login' })
    }
  },
  component: () => (
    <AppLayout>
      <Outlet />
    </AppLayout>
  ),
})
